//--------------------------------------------------------------
// CUSTOM
//--------------------------------------------------------------
const $ = window.jQuery;

if (typeof $ === 'function') {
const accordionTriggers = [...document.querySelectorAll('.js-disclosure-title')];

accordionTriggers.forEach(trigger => {
	trigger.addEventListener('click', e => {
		if (trigger.classList.contains('is-active')) {
			$(trigger).removeClass('is-active').ariaNotExpanded();
			return;
		}

		accordionTriggers.forEach(trigger => {
			$(trigger).removeClass('is-active').ariaNotExpanded();
		});

		$(trigger).addClass('is-active').toggleAriaExpanded();
	});
});

//Accordion and disclosures toggle
const disclosureButton = $('.accordion-button, .c-accordion__title, .c-category-list__trigger');

disclosureButton.on('click', function(event) { 
	event.preventDefault();
	
	const $that = $(this);
	if($(this).attr('data-close-neighbors')){
		const $parent_list = $(this).closest('ul');
		const $buttons = $parent_list.find('.accordion-button, .c-accordion__title');
		
		$buttons.each(function(){
			const $content = $(this).next();
			const $btn = $(this);
			if($content.hasClass('active') && event.target != $(this)[0]) {
				$content.removeClass('active').slideUp(400,function(){
					$btn.ariaNotExpanded();
				});
			}

		});
	}
	$(this).toggleAriaExpanded();
	$(this).toggleClass('active');
	$(this)
		.next()
		.toggleClass('active').slideToggle(400,function(){
			// Callback to animate if data-scroll-top is set
			if ($(this).is(":visible") && $that.attr('data-scroll-top')) {
				$('html, body').animate(
					{
						scrollTop: $that.offset().top
					}
				); 
			}
		});
	// Toggle arrow.
$(this)
		.find('svg')
		.toggleClass('active').slideToggle();

	
});
}
